import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Checkbox, DeleteIcon } from "@td/ui";
import styles from './styles.module.scss';

const ChecklistItem = ({ item: { text, completed }, onChange, onDelete }) => {
  const onCheckboxChange = useCallback(({ target: { checked } }) => {
    onChange({ text, completed: checked });
  }, [onChange, text]);

  return (
    <div className={classnames(styles.checklistItem, { [styles.checklistItemCompleted]: completed })} >
      <Checkbox
        checked={completed}
        onChange={onCheckboxChange}
        data-testid="care-team-tasks-checklist-item-checkbox"
      >
        { text }
      </Checkbox>
      <button
        type="button"
        className={styles.checklistItemDelete}
        onClick={onDelete}
        data-testid="care-team-tasks-checklist-item-delete-button"
      >
        <DeleteIcon
          width={12}
          height={12}
          fill="#181919"
        />
      </button>
    </div>
  );
};

ChecklistItem.propTypes = {
  item: PropTypes.shape({
    text: PropTypes.string.isRequired,
    completed: PropTypes.bool.isRequired
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ChecklistItem;
